import {
  getField,
  updateField
} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api'

function initialState() {
  return {
    list: {
      items: [],
      loaded: false,
      loaded_at: null,
    },
    filtered: {
      query: [],
      results: [],
      executed: false
    },
    active_links: null,
    expired_links: null,
  };
}

const state = initialState();

// actions
const actions = {
  async list(context, payload) {
    var response = await API.avails.list(payload)
    context.commit('SET_LIST_ITEMS', {
        items: response.avails
    })
    return response;
},
  async getActiveLinks(context, payload) {
    var response = await API.avails.listActiveLinks(payload);
    context.commit('SET_ACTIVE_LINKS', {
      links: response.result,
    });
    return response;
  },

  async getExpiredLinks(context, payload) {
    var response = await API.avails.listExpiredLinks(payload);
    context.commit('SET_EXPIRED_LINKS', {
      links: response.result,
    });
    return response;
  },

  async createInvitation(context, payload) {
    var response = await API.avails.createLink(payload);
    return response;
  },

  async update (context, payload) {
    var response = await API.avails.update (payload);

    context.commit ('UPDATE_ACTIVE_LINKS', {
      link: response.result,
    });

    context.dispatch (
      'app/showMessage',
      {
        message: 'Invitation updated successfully !',
        color: 'green',
      },
      DEFINES.USE_ROOT
    );

    return response;
  },

  async markExpire (context, payload) {
    var response = await API.avails.markExpire (payload);
    context.commit ('UPDATE_EXPIRED_LINKS', {
      link: response.result,
    });
    context.dispatch (
      'app/showMessage',
      {
        message: 'Link has been mark expired !',
        color: 'green',
      },
      DEFINES.USE_ROOT
    );
  },
};

// getters
const getters = {
  getField,
    getAvail: (state) => (id) => {
      return state.list.find(avail => {
          return film.id == id
      });
    },
    getActiveLinks: (state) => {
          return state.active_links;
    },
    getExpiredLinks: (state) => {
        return state.expired_links;
    }
};

// mutations
const mutations = {
  updateField,
    reset(state) {
        // acquire initial state
        const s = initialState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },

    SET_ACTIVE_LINKS(state, payload) {
        state.active_links = payload.links
    },

    SET_EXPIRED_LINKS(state, payload) {
        state.expired_links = payload.links
    },

    SET_LIST_ITEMS(state, payload) {
        state.list.items = payload.films
    },

  UPDATE_ACTIVE_LINKS (state, payload) {
    state.active_links[
      state.active_links.findIndex (link => link.id === payload.link.id)
    ] =
      payload.link;
  },
  UPDATE_EXPIRED_LINKS (state, payload) {
    state.active_links.splice (
      state.active_links.findIndex (link => link.id === payload.link.id),
      1
    );
    state.expired_links.unshift (payload.link);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
